import * as React from "react";
import { AV_CATEGORY_LOOKUP, PRODUCT_STATUS_TYPE_LOOKUP } from "../../../lookup/Consts";
import { getLookupValues, mapLookupKey } from "../../../lookup/services/LookupHelpers";
import { ILookupInstance } from "../../../lookup/types/ILookup";
import { MemberPortalSearchType } from "../../../redux/types/MemberPortalSearchType";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { SizedCheckboxDataInput } from "../../../repertoire/components/checkboxDataInput/CheckboxDataInput";
import SizedDateDataInput from "../../../repertoire/components/dateDataInput/DateDataInput";
import { SizedDropdownDataInput } from "../../../repertoire/components/dropdownDataInput/DropdownDataInput";
import SearchResultsTable from "../../../repertoire/components/searchResultsTable/SearchResultsTable";
import SearchView, { ISearchViewProps } from "../../../repertoire/components/searchView/SearchView";
import SelectionTable from "../../../repertoire/components/selectionTable/SelectionTable";
import { SizedTextDataInput } from "../../../repertoire/components/textDataInput/TextDataInput";
import { SEARCH_VIEW_PRODUCTS } from "../../../repertoire/Consts";
import { IRepertoireField } from "../../../repertoire/types/IRepertoireField";
import { ADD_TO_PACKAGE_ACTION, DRAFT_CUESHEET_STATUS_OPTIONS, REPERTOIRE_STATUS_OPTIONS, SEARCH_VIEW_REGISTERED_CUE_SHEETS, SET_LIST_MODAL_SEARCH_VIEW } from "../../Consts";
import { ICueSheetsSearchQuery } from "../../types/ICueSheetsSearchQuery";
import { IMembersPortalField } from "../../types/IMembersPortalField";
import { MembersPortalRoles } from "../../../redux/types/MembersPortalRoles";
import { MembersPortalService } from "../../../redux/services/MembersPortalService";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import CreateFullCataloguePackageButton from "../../sharedComponents/button/CreateFullCataloguePackageButton";


const CUESHEET_STATUS = 'registeredCueSheetStatus';
const CUESHEET_TYPE = 'registeredCueSheetProductionType';

interface ICueSheetsSearchViewProps extends ISearchViewProps {
    paginationSection?: string;
}

export default class CueSheetsSearchView extends SearchView {
    declare props: ICueSheetsSearchViewProps;
    constructor(props: ISearchViewProps) {
        super(props);

        super.state = {
            tableContents: [],
            draftSetListID: "",
            registeredCueSheetStatus: "",
            registeredCueSheetTitle: "",
            registeredCueSheetProductionType: "",
            registeredCueSheetProductionTypeOptions: [],
            registeredCueSheetOptions: [],
            includeCueSheetsWithMyRegisteredWorks: true
        };
    }

    componentDidMount = () => {
        let registeredCueSheetOptions: { code: string, description: string }[] = [];
        let registeredCueSheetProductionTypeOptions: { code: string, description: string }[] = [];
        let registeredCueSheetProductionType: string | undefined;
        let registeredCueSheetStatus: string | undefined;

        if (this.props.memberPortalSearchType.code === MemberPortalSearchType.MyDraftSearch.code) {
            registeredCueSheetOptions.push({ code: "DRAFTSUB", description: "Draft Submitted" });
            registeredCueSheetStatus = "DRAFTSUB";
        }
        else {
            registeredCueSheetOptions = this.getRepertoireStatusOptions(this.props.lookupValues);
        }

        this.setState({ registeredCueSheetStatus, registeredCueSheetOptions });
    }

    getRepertoireStatusOptions = (lookupValues): ILookupInstance[] => {
        const values = getLookupValues(PRODUCT_STATUS_TYPE_LOOKUP, lookupValues);
        return values?.filter(s => REPERTOIRE_STATUS_OPTIONS.includes(s.code.toUpperCase())) || [];
    }

    renderSearchFieldsRegistredCueSheets = () => {
        const { searchViewData, componentInstance, memberPortalSearchType, lookupValues, dataSource } = this.props;

        if (!searchViewData || !searchViewData.fields) return null;

        let filteredSearchFields = searchViewData.fields.filter(
            (searchField: IRepertoireField | IMembersPortalField) =>
                searchField.componentInstance === componentInstance
        );

        let filteredSearchFieldsMapper = (searchField: IRepertoireField | IMembersPortalField, index: number): React.ReactElement => {
            let reactElement: React.ReactElement = <></>;

            if ((searchField.fieldType === 'text' || searchField.fieldType === 'integer' || searchField.fieldType === 'decimal')) {
                reactElement =
                    <div key={index}>
                        <SizedTextDataInput
                            fieldType={searchField.fieldType}
                            useEnterSubmit={true}
                            label={searchField.data}
                            fieldName={searchField.name}
                            changeData={this.disabledSearchFields(searchField.name) ? this.changeDataDisabled : (value, fieldName) => this.changeTextData(value, fieldName)}
                            handleKeyDown={this.keyDownSubmit}
                            value={this.state[searchField.name]}
                            readOnly={this.disabledSearchFields(searchField.name)}
                            isHidden={searchField.hidden}
                        />
                    </div>;
            }
            else if (searchField.fieldType === 'date')
                reactElement =
                    <div key={index}>
                        <SizedDateDataInput
                            value={this.state[searchField.name]}
                            fieldName={searchField.name}
                            changeData={this.changeData}
                            label={searchField.data}
                            isHidden={searchField.hidden}
                        />
                    </div>
            else if (searchField.fieldType === 'checkbox' && memberPortalSearchType.code === MemberPortalSearchType.MyRegisteredSearch.code)
                reactElement =
                    <div key={index}>
                        <SizedCheckboxDataInput
                            label={searchField.data}
                            fieldName={searchField.name}
                            value={this.state[searchField.name]}
                            changeData={this.changeData}
                            readonly={false}
                            style={{ paddingTop: "5%" }}
                        />
                    </div>
            else if (searchField.fieldType === 'select_action') {

                if (!(memberPortalSearchType.code === MemberPortalSearchType.MyDraftSearch.code && searchField.name === CUESHEET_TYPE)) {

                    let options: { code: string, description: string }[] = [];
                    let value: string | undefined;

                    if (lookupValues) {
                        if (searchField.name === CUESHEET_TYPE) {
                            options.push(...getLookupValues(AV_CATEGORY_LOOKUP, lookupValues) || [])
                        }
                        else if (searchField.name === CUESHEET_STATUS) {
                            options.push(...getLookupValues(PRODUCT_STATUS_TYPE_LOOKUP, lookupValues) || [])
                        }
                    }
                    if (searchField.name === CUESHEET_STATUS) {
                        const allowSet = memberPortalSearchType.code === MemberPortalSearchType.MyDraftSearch.code ? DRAFT_CUESHEET_STATUS_OPTIONS : REPERTOIRE_STATUS_OPTIONS;
                        options = options.filter(s => allowSet.includes(s.code.toUpperCase()));
                    }

                    if (searchField.name === CUESHEET_STATUS) {
                        value = this.state.registeredCueSheetStatus;
                    } else if (searchField.name === CUESHEET_TYPE) {
                        value = this.state.registeredCueSheetProductionType;
                    }

                    reactElement = (
                        <div key={index}>
                            <SizedDropdownDataInput
                                label={searchField.data}
                                fieldName={searchField.name}
                                changeData={memberPortalSearchType.code === MemberPortalSearchType.MyDraftSearch.code ? () => { } : this.changeData}
                                value={value}
                                options={options}
                                allowNull={true}
                                isHidden={searchField.hidden}
                                componentInstance={componentInstance}
                                readOnly={false}
                                portalType={MEMBERS_PORTAL}
                            />
                        </div>
                    );

                }
            }

            return reactElement;

        };

        return filteredSearchFields.map(filteredSearchFieldsMapper);
    };

    buildCueSheetSearchCriteria = (): ICueSheetsSearchQuery => {
        const {
            registeredCueSheetID,
            registeredCueSheetStatus,
            registeredCueSheetTitle,
            registeredCueSheetProductionType,
            includeCueSheetsWithMyRegisteredWorks,
        } = this.state;


        return {
            title: registeredCueSheetTitle || null,
            status: registeredCueSheetStatus || null,
            currentUserNameNumber: this.props.currentUserNameNumber || null,
            cueSheetID: registeredCueSheetID || null,
            dataSource: this.props.dataSource || null,
            productionType: registeredCueSheetProductionType || null,
            includeCueSheetsWithMyRegisteredWorks: Boolean(includeCueSheetsWithMyRegisteredWorks),
        };
    };

    onClickSearch = () => {
        const { setPageOne } = this.state;
        const { resetPagination, searchCueSheets, paginationSection, componentInstance } = this.props;

        resetPagination(paginationSection || componentInstance);
        this.setState({ setPageOne: setPageOne + 1 });

        searchCueSheets(this.buildCueSheetSearchCriteria());
    };

    renderSearchResults() {
        const {
            searchResultsTableData,
            componentInstance,
            searchSuccessful,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            updatePagination,
            lookupValues,
            sortSearchResults,
            cueSheetsSearchResults,
            addSetListToLivePerformance,
            getCueSheetsDetails,
            hideModal,
            expandAll,
            expandedProductResults,
            expandProductResult,
            expandAllResults,
            roles,
            addToPackages,
            removeFromPackages,
            showYesNoPrompt,
            packageActionsDisabled,
            enablePackageActions,
        } = this.props;

        const packageActionsEnabled = enablePackageActions !== false;

        const effectiveSearchResultsTableData = packageActionsEnabled
            ? searchResultsTableData
            : {
                ...searchResultsTableData,
                fields: searchResultsTableData.fields.filter(
                    field =>
                        field.fieldType !== ADD_TO_PACKAGE_ACTION &&
                        field.name !== ADD_TO_PACKAGE_ACTION &&
                        field.name !== "selectAllForPackage" &&
                        field.name !== "processingSelectAllForPackage"
                ),
            };

        const { setPageOne } = this.state;

        if (searchSuccessful &&
            (!!cueSheetsSearchResults && cueSheetsSearchResults.length <= 0)) {
            return (
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                        {searchResultsTableData.fields.find(f => f.name == "noSearchResultsMessage")?.data || "No results found."}
                    </div>
                </div>
            )
        } else if (cueSheetsSearchResults && cueSheetsSearchResults.length >= 1) {
            return (<div className="row">
                {componentInstance === SET_LIST_MODAL_SEARCH_VIEW ?
                    <SelectionTable
                        key={setPageOne}
                        searchResultsTableData={searchResultsTableData}
                        tableContents={cueSheetsSearchResults}
                        componentInstance={componentInstance}
                        sourceItem={undefined}
                        addSetListToLivePerformance={addSetListToLivePerformance}
                        hideModal={hideModal}
                        expandedResults={undefined}
                        expandAll={undefined}
                        expandResult={undefined}
                        expandAllResults={undefined}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        updatePagination={updatePagination}
                        repertoireSection={SEARCH_VIEW_PRODUCTS}
                    /> :
                    <div className="col-md-12 searchResultsDiv">
                        <SearchResultsTable
                            key={setPageOne}
                            searchResultsTableData={effectiveSearchResultsTableData}
                            tableContents={cueSheetsSearchResults}
                            componentInstance={componentInstance}
                            indexOfFirstResult={indexOfFirstResult}
                            indexOfLastResult={indexOfLastResult}
                            resultsPerPage={resultsPerPage}
                            currentPage={currentPage}
                            updatePagination={updatePagination}
                            repertoireSection={this.props.paginationSection || SEARCH_VIEW_REGISTERED_CUE_SHEETS}
                            sortSearchResults={sortSearchResults}
                            lookupValues={lookupValues}
                            getCueSheetsDetails={getCueSheetsDetails}
                            expandedResults={expandedProductResults}
                            expandResult={expandProductResult}
                            expandAll={expandAll}
                            expandAllResults={expandAllResults}
                            roles={roles}
                            addToPackages={packageActionsEnabled ? addToPackages : undefined}
                            removeFromPackages={packageActionsEnabled ? removeFromPackages : undefined}
                            resultPageData={effectiveSearchResultsTableData}
                            showYesNoPrompt={packageActionsEnabled ? showYesNoPrompt : undefined}
                            hideModal={packageActionsEnabled ? hideModal : undefined}
                            packageActionsDisabled={!packageActionsEnabled || packageActionsDisabled}
                        />

                    </div>}
            </div>)
        } else if (searchSuccessful === false) {
            return (
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                        {searchResultsTableData.fields.find(f => f.name == "noSearchResultsMessage")?.data || "No results found."}
                    </div>
                </div>
            )
        }
    }
    render() {
        const { searchViewData, searchDisabled, tabs, activeTab, memberPortalSearchType, createCueSheetPackageFromCriteria, fullCataloguePackagePending, saveInProgress, fullCatalogueCreationDisabled, enablePackageActions } = this.props

        const menuName = tabs[activeTab]?.name;
        const hasPermission = MembersPortalService.hasPermissionForMenu(menuName, MembersPortalRoles.ReadOnlyAccess);

        const isRegisteredPage = memberPortalSearchType.code !== MemberPortalSearchType.MyDraftSearch.code;
        const packageActionsEnabled = enablePackageActions !== false;
        const fullCatalogueButtonText = searchViewData.fields.find(field => field.name?.toString() === "createPackageFromSearch" && field.componentInstance === this.props.componentInstance)?.data || "Add All Cue Sheets to Package";

        return (
            <div className="searchView">
                <div key='searchFields' className="row">
                    {this.renderSearchFieldsRegistredCueSheets()}
                </div>
                <div key='action' className="row">
                    {packageActionsEnabled && isRegisteredPage && (
                        <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <CreateFullCataloguePackageButton<ICueSheetsSearchQuery>
                                buttonText={fullCatalogueButtonText}
                                fullCataloguePackagePending={fullCataloguePackagePending}
                                saveInProgress={saveInProgress}
                                disabled={fullCatalogueCreationDisabled}
                                createPackageFromCriteria={createCueSheetPackageFromCriteria}
                                buildCriteria={this.buildCueSheetSearchCriteria}
                                searchViewData={searchViewData}
                            />
                        </div>
                    )}
                    <div className={
                        (packageActionsEnabled && isRegisteredPage)
                            ? "form-group col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-6 col-xs-12"
                            : "form-group col-lg-4 col-lg-offset-8 col-md-4 col-md-offset-8 col-sm-6 col-sm-offset-6 col-xs-12"
                    }>
                        <ActionButton buttonText={searchViewData.fields.find(v => v.name == "search").data} buttonAction={this.onClickSearch} disabled={searchDisabled} showTooltip={!hasPermission} />
                    </div>
                </div>
                <div key='results'>
                    {this.renderSearchResults()}
                </div>
            </div>
        )
    }
}